import Box from '@mui/material/Box';
import { Typography, Avatar } from '@mui/material';

const Constants = require("../constants/Constants");
const IMAGE_URL = Constants.IMAGE_URL;
const CHARACTERS = Constants.CHARACTERS;

const StatsPlayerHeader = ({ characterId, firstName, lastName }) => {
    const characterIndex = parseInt(characterId) - 1;
    const endColor = CHARACTERS[characterIndex]?.endColor || 'black';
    const avatarUrl = `${IMAGE_URL}${CHARACTERS[characterIndex]?.url || ""}`;

    return (
        <>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    m: 1,
                    borderRadius: 2,
                    border: 0,
                    width: "300px",
                    boxShadow: 0,
                }}
            >
                <Avatar
                    alt={`Avatar ${characterId}`}
                    src={avatarUrl}
                    variant="square"
                    sx={{ width: 100, height: 100 }}
                />
            </Box>

            <Box display="flex" flexDirection="column" alignItems="center" sx={{ marginTop: 1 }}>
                <Typography
                    variant="body"
                    sx={{
                        fontFamily: '"Press Start 2P", sans-serif',
                        fontWeight: 'bold',
                        fontSize: '1.5rem',
                        color: endColor,
                        textShadow: '3px 3px 6px rgba(0, 0, 0, 0.9)',
                        letterSpacing: '2px',
                        textTransform: 'uppercase',
                        marginBottom: '5px',
                    }}
                >
                    {firstName}
                </Typography>
                <Typography
                    variant="body"
                    sx={{
                        fontFamily: '"Press Start 2P", sans-serif',
                        fontWeight: 'bold',
                        fontSize: '1.5rem',
                        color: endColor,
                        textShadow: '3px 3px 6px rgba(0, 0, 0, 0.9)', 
                        letterSpacing: '2px',
                        textTransform: 'uppercase',
                    }}
                >
                    {lastName}
                </Typography>
            </Box>
        </>
    );
};

export default StatsPlayerHeader;
